import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import 'default-passive-events'
import BaseBigimg from './components/BaseBigimg'
import './assets/css/main.css'
import FetchCommonData from './plugins/FetchCommonData/v2'
Vue.use(FetchCommonData)
Vue.config.productionTip = false
Vue.component('BaseBigimg', BaseBigimg)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')